var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signiture",on:{"click":_vm.toggle}},[_c('p',{staticClass:"signiture__text font-hand text-gray-600 pointer-events-none"},[_vm._v(" Oleh Kurylas ")])])}
var staticRenderFns = []

export { render, staticRenderFns }